import { MissionToExternalStaff } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff'
import { MissionToExternalStaffInput } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function addExternalStaffsToMission(input: IdInput<MissionToExternalStaffInput>) {
  const { id, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.missions.addExternalStaffsToMission.url, { id }))
    .post<MissionToExternalStaff>(rest)
}
